import React from "react";
import { type Types } from "@cornerstonejs/core";

interface StatusBarProps {
  worldCoordinates: Types.Point3 | null;
  windowWidth: number;
  windowLevel: number;
  visibleViewports: {
    axial: boolean;
    sagittal: boolean;
    coronal: boolean;
  };
  onToggleViewport: (name: "axial" | "sagittal" | "coronal") => void;
}

const StatusBar: React.FC<StatusBarProps> = ({
  worldCoordinates,
  windowWidth,
  windowLevel,
  visibleViewports,
  onToggleViewport,
}) => {
  const formatCoord = (coord: number | undefined) => coord?.toFixed(2) ?? "N/A";

  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        color: "white",
        padding: "5px 10px",
        fontSize: "12px",
        zIndex: 100, // Ensure it's above viewports
        boxSizing: "border-box",
        textAlign: "left",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <span>
        WW: {windowWidth.toFixed(0)} | WL: {windowLevel.toFixed(0)} | {worldCoordinates
          ? `World Coords (mm): X: ${formatCoord(
              worldCoordinates[0]
            )}, Y: ${formatCoord(worldCoordinates[1])}, Z: ${formatCoord(
              worldCoordinates[2]
            )}`
          : "World Coords (mm): N/A"}
      </span>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {/* Miniature viewer with 3 boxes */}
        <div
          style={{
            display: "flex",
            gap: 4,
            background: "#222",
            borderRadius: 4,
            padding: 2,
          }}
        >
          <div
            title="Toggle Axial"
            onClick={() => onToggleViewport("axial")}
            style={{
              width: 18,
              height: 18,
              background: visibleViewports.axial ? "#4caf50" : "#888",
              border: "1px solid #fff",
              borderRadius: 2,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 10,
              color: "#fff",
              userSelect: "none",
            }}
          >
            AX
          </div>
          <div
            title="Toggle Sagittal"
            onClick={() => onToggleViewport("sagittal")}
            style={{
              width: 18,
              height: 18,
              background: visibleViewports.sagittal ? "#2196f3" : "#888",
              border: "1px solid #fff",
              borderRadius: 2,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 10,
              color: "#fff",
              userSelect: "none",
            }}
          >
            SG
          </div>
          <div
            title="Toggle Coronal"
            onClick={() => onToggleViewport("coronal")}
            style={{
              width: 18,
              height: 18,
              background: visibleViewports.coronal ? "#ff9800" : "#888",
              border: "1px solid #fff",
              borderRadius: 2,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 10,
              color: "#fff",
              userSelect: "none",
            }}
          >
            CR
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusBar;
